export default __webpack_public_path__ + "static/media/presentation_(169)_1920x1080px.02d50739.png";